import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const Pdfdialog = ({open,setopen,files})=>{

    console.log(files,"files in popup");
    
  



    return(
     <Dialog open={open} onClose={()=>setopen(false)}>
        <DialogTitle sx={{display:"flex",justifyContent:"center"}}>Document</DialogTitle>

        <DialogContent>
        <table>
            <thead>
               <tr>
                <th>
                    Title
                </th>

                   <th>
                  Actions
                </th>

               </tr>
            </thead>
            <tbody>
              {
               files.length>0 ? 
               
               files?.map((file)=>(
                    <tr style={{border:"1px solid grey"}}>
                <td style={{border:"1px solid grey",padding:2,borderRadius:5}}>
                    {file?.name}
                </td>

                      <td style={{border:"1px solid grey",padding:2,borderRadius:5}}>
                        <div style={{width:"100%",display:"flex",justifyContent:"space-evenly"}}>
                             <a href={file?.url} download={file?.name} style={{ color: "inherit" }}>
                         <IconButton>
                           <DownloadIcon />
                         </IconButton>
                         </a>

                          <a href={file?.url} target="_blank" rel="noopener noreferrer">
                          <IconButton >
                             <RemoveRedEyeIcon />
                             


                            
                         </IconButton>
                         </a>
                          {/* <IconButton>
                            <DeleteOutlineIcon />  
                         </IconButton> */}
                        </div>
                      
                </td>

                </tr>


                ))
                :
                <h6>
                    No Documents to view
                </h6>
              }
            </tbody>
        </table>
        </DialogContent>

        <DialogActions sx={{display:"flex",justifyContent:"center"}}>
          <Button onClick={()=>setopen(false)} color="primary" variant="outlined" sx={{color:"red"}}>
            Cancel
          </Button>
     
        </DialogActions>
      </Dialog>
    )
}
export default Pdfdialog








